import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./SearchCountContainer.module.scss";

import { SearchBar } from "../../common";
import localesKeys from "../../../locales/localesKeys.json";

const SearchCountContainer = ({ startPage, endPage, total, onSearch }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.searchContainer}>
      <div className={styles.labelDetails}>
        <h2>
          {t(localesKeys.GRANT_LANGUAGES_SHOWING, {
            startPage,
            endPage,
            total,
          })}
        </h2>
      </div>
      <SearchBar
        className={"desktopSearchBar"}
        placeholder={t(localesKeys.SEARCH)}
        onSearch={onSearch}
      />
    </div>
  );
};

export default SearchCountContainer;
